import { IMateriallyAccountableEmployeeDto } from "../dtos/materially-accountable-employee.dto";

export class MateriallyAccountableEmployee {
  readonly id: string;
  name: string;
  isDeleted: boolean;

  constructor(id: string) {
    this.id = id;
    this.isDeleted = false;
  }

  get asDto(): Partial<IMateriallyAccountableEmployeeDto> {
    return {
      id: this.id,
      name: this.name,
    };
  }

  updateFromDto(dto: IMateriallyAccountableEmployeeDto): void {
    this.name = dto.name;
    this.isDeleted = dto.isDeleted === true;
  }
}
